module.exports = __webpack_public_path__ + "img/update.0762e267.svg";